import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ClearAllIcon(props: IconProps) {
    return <Icon {...props} iconKey={"clear_all"}/>
}
